<template>
    <pie-chart
        :chart-data="chartData"
        :tooltips="false"
        :doughnut="true"
        :center-text="centerText"
        :display-legend="false"
        :cutout-percentage="90"
        :animate="animate"
    />
</template>

<script>
export default {
    props: ['percentage', 'animate'],
    computed: {
        chartData() {
            return [
                {
                    value: Math.min(this.percentage, 100),
                    background: this.getColorForPercentage(
                        this.percentage / 100,
                    ),
                },
                {
                    value: Math.max(100 - this.percentage, 0),
                    background: 'transparent',
                },
            ];
        },
        centerText() {
            if (this.percentage === 0) {
                return '—';
            }

            return this.percentage.toString() + '%';
        },
    },
    methods: {
        getColorForPercentage(pct) {
            pct = Math.min(pct, 1);

            const percentColors = [
                { pct: 0.0, color: { r: 0xf4, g: 0x43, b: 36 } },
                { pct: 0.25, color: { r: 0xf4, g: 0x43, b: 36 } },
                { pct: 1.0, color: { r: 0x4c, g: 0xaf, b: 50 } },
            ];

            for (var i = 1; i < percentColors.length - 1; i++) {
                if (pct < percentColors[i].pct) {
                    break;
                }
            }

            const lower = percentColors[i - 1];
            const upper = percentColors[i];
            const range = upper.pct - lower.pct;
            const rangePct = (pct - lower.pct) / range;
            const pctLower = 1 - rangePct;
            const pctUpper = rangePct;

            const color = {
                r: Math.floor(
                    lower.color.r * pctLower + upper.color.r * pctUpper,
                ),
                g: Math.floor(
                    lower.color.g * pctLower + upper.color.g * pctUpper,
                ),
                b: Math.floor(
                    lower.color.b * pctLower + upper.color.b * pctUpper,
                ),
            };

            return `rgb(${[color.r, color.g, color.b].join(',')})`;
        },
    },
};
</script>
